import { Action, State, StateContext } from '@ngxs/store';

import { OptIns } from './opt-ins.model';
import * as OptInActions from './opt-ins.actions';

@State<OptIns>({
  name: 'optIns',
  defaults: new OptIns()
})
export class OptInsState {
  @Action(OptInActions.SetAnonymous)
  setAnonymous(
    { getState, setState }: StateContext<OptIns>,
    { payload }: OptInActions.SetAnonymous
  ) {
    setState({ ...getState(), anonymous: payload });
  }

  @Action(OptInActions.SetAnonymousAndFundraiser)
  setAnonymousAndFundraiser(
    { getState, setState }: StateContext<OptIns>,
    { payload }: OptInActions.SetAnonymousAndFundraiser
  ) {
    setState({
      ...getState(),
      anonymous: payload.anonymous,
      showForFundraiser: payload.showForFundraiser
    });
  }

  @Action(OptInActions.SetEmails)
  setEmails(
    { getState, setState }: StateContext<OptIns>,
    { payload }: OptInActions.SetEmails
  ) {
    setState({ ...getState(), emails: payload });
  }

  @Action(OptInActions.SetPayFee)
  setPayFee(
    { getState, setState }: StateContext<OptIns>,
    { payload }: OptInActions.SetPayFee
  ) {
    setState({
      ...getState(),
      payFee: payload.enabled,
      feeAmount: payload.amount
    });
  }
}
